import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import ConfirmOrder from "../components/confirmOrder/ConfirmOrder";

export default function ConfirmOrderView() {
  return (
    <div className="pageWrapper">
      <Header title="Bevestiging bestelling" needsLocation="Yes" />
      <div className="contentWrapper fadeInDelayed">
        <ConfirmOrder />
      </div>
      <BottomNavBar />
    </div>
  );
}
